import icon from 'vue-svgicon';

icon.register({
    'light/email-action-unread': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<rect pid="0" x=".5" y="3.954" width="23" height="16" rx="2" ry="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M22.911 4.536L12 13.454 1.089 4.536"/>`,
    },
});
